export { TextCard, type TextCardProps } from "./TextCard";
